import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { PATH } from '../../constants/router'
import { useAppUserContext } from '../../context/AppUserContext'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import HeaderPartner from '../../components/FeaturesComponent/headerPartner'
import './index.scss'

export default function LoginByToken() {
  const history = useHistory()
  const location = useLocation()
  const { confirmSdkTokenData } = useAppUserContext()
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const token = searchParams.get('token')
    const sdkToken = searchParams.get('sdkToken')
    
    const tokenToSave = token || sdkToken

    if (tokenToSave) {
      confirmSdkTokenData(tokenToSave)
      history.replace(PATH.HOME)
    } else {
      setHasError(true)
    }
  }, [history, location.search, confirmSdkTokenData])

  if (hasError) {
    return (
      <LayoutPartner>
        <HeaderPartner title="" />
        <div className="LoginByToken_errorText">Tải dữ liệu thất bại.</div>
      </LayoutPartner>
    )
  }

  return (
    <LayoutPartner>
      <HeaderPartner title="" />
      <div className="LoginByTokenBrandLoading">
        <div className="LoginByTokenBrandLoading-spinner" />
        <img src={'/logo.png'} alt="loading" />
      </div>
    </LayoutPartner>
  )
}
